<div class="open-estimate-contanier d-flex flex-column" closeOnEscape>
    <div class="open-estimate-content">
        <div class="row col-sm-12" [formGroup]="openEstimateFormgroup">
            <div class="col-sm-5">
                <div class="row row-align">
                    <div class="label-width">{{'ESTIMATE_ID' | translate}}</div>
                    <div class="col-sm-9 ps-0">
                        <mat-form-field appearance="outline" class="col-sm-12">
                            <input matInput formControlName="estimateID" #tooltip="matTooltip"
                                [matTooltipPosition]="'above'" matTooltip="unicode characters are not allowed"
                                [matTooltipDisabled]="openEstimateFormgroup.get('estimateID')?.valid || openEstimateFormgroup.get('estimateID')?.pristine" />
                        </mat-form-field>
                    </div>
                </div>

                <div class="row row-align">
                    <div class="label-width">{{'NAME' | translate}}</div>
                    <div class="col-sm-9 ps-0">
                        <mat-form-field appearance="outline" class="alignLabel col-sm-12">
                            <input matInput formControlName="estimateName" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row row-align ">
                    <div class="label-width">{{'DESCRIPTION' | translate}}</div>
                    <div class="col-sm-9 ps-0">
                        <mat-form-field appearance="outline" class="alignLabel col-sm-12">
                            <input matInput formControlName="estimateDescription" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row row-align">
                    <div class="label-width">{{'DATE_RANGE' | translate}}</div>
                    <div class="col-sm-9 ps-0">
                        <mat-form-field class="col-sm-12" appearance="outline">
                            <mat-select formControlName="dateRange">
                                @for (item of dateRangeList; track item) {
                                <mat-option class="optionHeight" [value]="item.key">{{item.label}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row row-align">
                    <div class="label-width"></div>
                    <div class="col-sm-9 ps-0 space-between">
                        <mat-form-field appearance="outline">
                            <mat-select formControlName="dates" (selectionChange)="onDatesChange($event.value)">
                                @for (item of datesList; track item) {
                                <mat-option class="optionHeight" [value]="item.key">{{item.label}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-select formControlName="month">
                                @for (item of months; track item) {
                                <mat-option class="optionHeight" [value]="item.key">{{item.label}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-select formControlName="year">
                                @for (item of years; track item) {
                                <mat-option class="optionHeight" [value]="item">{{item}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                @if (false) { <!-- Hiding Check Archive for Phase 1 -->
                <div class="row row-align">
                    <div class="col-sm-9 checkbox-container ps-0">
                        <mat-checkbox color="primary" class="ps-0" formControlName="checkArchive">{{'CHECK_ARCHIVE' |
                            translate}}</mat-checkbox>
                    </div>
                </div>
                }
            </div>
            <!-- 2nd column -->
            <div class="col-sm-4 ps-0">
                <div class="row row-align">
                    <div class="label-width">{{'BUSINESS' | translate}}</div>
                    <div class="col-sm-8 ps-0">
                        <mat-form-field class="col-sm-12" appearance="outline">
                            <mat-select formControlName="estimateBusiness"
                                (selectionChange)="onBusinessChange($event.value)">
                                @for (item of businessList; track item) {
                                <mat-option class="optionHeight"
                                    [value]="item.businessCode">{{item.businessName}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row row-align">
                    <div class="label-width">{{'SEGMENT' | translate}}</div>
                    <div class="col-sm-8 ps-0">
                        <mat-form-field class="col-sm-12" appearance="outline">
                            <mat-select formControlName="estimateSegment"
                                (selectionChange)="onSegmentChange($event.value)">
                                @for (item of segmentList; track item) {
                                <mat-option class="optionHeight" [value]="item.zweigId">{{item.zweigName}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row row-align">
                    <div class="label-width">{{'HIERARCHY' | translate}}</div>
                    <div class="col-sm-8 ps-0">
                        <mat-form-field class="col-sm-12" appearance="outline">
                            <mat-select formControlName="estimateHierarchy">
                                @for (item of hierarchyList; track item) {
                                <mat-option class="optionHeight"
                                    [value]="item.subSegmentId">{{item.subSegment}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row row-align">
                    <div class="label-width">{{'TYPE' | translate}}</div>
                    <div class="col-sm-8 ps-0">
                        <mat-form-field class="col-sm-12" appearance="outline">
                            <mat-select formControlName="estimateType">
                                @for (item of typeList; track item) {
                                <mat-option class="optionHeight" [value]="item.id">{{item.description}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row row-align">
                    <div class="label-width">{{'STATUS' | translate}}</div>
                    <div class="col-sm-8 ps-0">
                        <mat-form-field class="col-sm-12" appearance="outline">
                            <mat-select formControlName="estimateStatus">
                                @for (item of statusList; track item) {
                                <mat-option class="optionHeight" [value]="item.id">{{item.description}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <!-- 3rd column -->
            <div class="col-sm-3 last-column px-0">
                <div class="row row-align">
                    <div class="label-width">{{'CUSTOMER' | translate}}</div>
                    <div class="col-sm-8 ps-0">
                        <mat-form-field appearance="outline" class="alignLabel col-sm-12">
                            <input matInput formControlName="customerName" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row row-align">
                    <div class="label-width">{{'START_DATE' | translate}}</div>
                    <div class="col-sm-8 ps-0">
                        <mat-form-field appearance="outline" class="col-sm-12">
                            <mat-label>{{'START_DATE' | translate}}</mat-label>
                            <input matInput [matDatepicker]="startDatePicker" formControlName="estimateStartDate">
                            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row row-align">
                    <div class="label-width">{{'END_DATE' | translate}}</div>
                    <div class="col-sm-8 ps-0">
                        <mat-form-field appearance="outline" class="col-sm-12">
                            <mat-label>{{'END_DATE' | translate}}</mat-label>
                            <input matInput [matDatepicker]="endDatePicker" formControlName="estimateEndDate">
                            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #endDatePicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row row-align">
                    <div class="label-width">{{'CREATED_BY' | translate}}</div>
                    <div class="col-sm-8 ps-0">
                        <mat-form-field appearance="outline" class="alignLabel col-sm-12">
                            <input matInput formControlName="createdBy" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row row-align">
                    <div class="label-width">{{'MODIFIED_BY' | translate}}</div>
                    <div class="col-sm-8 ps-0">
                        <mat-form-field appearance="outline" class="alignLabel col-sm-12">
                            <input matInput formControlName="modifiedBy" />
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <button mat-raised-button class="search-btn" color="primary" (click)="searchEstimate()"
            [disabled]="!openEstimateFormgroup.valid">{{'SEARCH' | translate}}</button>
        <br>
        <div class="row">
            <div class="custom-table">
                <div class="table-responsive">
                    <table mat-table table-border [dataSource]="estimateTableData" matSort>

                        <ng-container matColumnDef="estimateID">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'ESTIMATE_ID' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.estimateID}} </td>
                        </ng-container>
                        <ng-container matColumnDef="estimateName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'ESTIMATE_NAME' | translate}} </th>
                            <td mat-cell *matCellDef="let element" class="center-align"> {{element.estimateName}} </td>
                        </ng-container>
                        <ng-container matColumnDef="estimateDescription">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'DESCRIPTION' | translate}} </th>
                            <td mat-cell class="right-align" *matCellDef="let element">{{element.description}}</td>
                        </ng-container>
                        <ng-container matColumnDef="dateModified">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'DATE_MODIFIED' | translate}}</th>
                            <td mat-cell class="right-align" *matCellDef="let element"> {{element.modifiedDate |
                                multilingualDate:'dateTime'}} </td>
                        </ng-container>
                        <ng-container matColumnDef="dateCreated">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'DATE_CREATED' | translate}}</th>
                            <td mat-cell class="right-align" *matCellDef="let element"> {{element.creationDate |
                                multilingualDate:'dateTime'}} </td>
                        </ng-container>
                        <ng-container matColumnDef="estimateBusiness">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'BUSINESS' | translate}}</th>
                            <td mat-cell class="right-align " *matCellDef="let element"> {{element.business}} </td>
                        </ng-container>
                        <ng-container matColumnDef="estimateSegment">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'SEGMENT' | translate}}</th>
                            <td mat-cell *matCellDef="let element" class="center-align"> {{element.segment}} </td>
                        </ng-container>
                        <ng-container matColumnDef="estimateType">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ESTIMATE_TYPE' | translate}}</th>
                            <td mat-cell class="right-align" *matCellDef="let element"> {{element.estimateType}} </td>
                        </ng-container>
                        <ng-container matColumnDef="estimateStatus">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ESTIMATE_STATUS' | translate}}</th>
                            <td mat-cell class="right-align" *matCellDef="let element"> {{element.estimateStatus}} </td>
                        </ng-container>
                        <ng-container matColumnDef="customerName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'CUSTOMER' | translate}}</th>
                            <td mat-cell class="right-align" *matCellDef="let element"> {{element.customer}} </td>
                        </ng-container>
                        <ng-container matColumnDef="estimateStartDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'START_DATE' | translate}}</th>
                            <td mat-cell class="right-align" *matCellDef="let element"> {{element.startDate |
                                multilingualDate:'dateTime' : false}} </td>
                        </ng-container>
                        <ng-container matColumnDef="estimateEndDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'END_DATE' | translate}}</th>
                            <td mat-cell class="right-align" *matCellDef="let element"> {{element.endDate |
                                multilingualDate:'dateTime' : false}} </td>
                        </ng-container>
                        <ng-container matColumnDef="estimateSource">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'SOURCE' | translate}}</th>
                            <td mat-cell class="right-align" *matCellDef="let element"> {{element.source | uppercase |
                                translate}} </td>
                        </ng-container>
                        <ng-container matColumnDef="sellPrice">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'SELL_PRICE' | translate}}</th>
                            <td mat-cell class="right-align" *matCellDef="let element"> {{element.sellPrice |
                                multilingualCurrency}} </td>
                        </ng-container>
                        <ng-container matColumnDef="gm">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'GM_PERCENTAGE' | translate}}</th>
                            <td mat-cell class="right-align" *matCellDef="let element"> {{element.gm |
                                decimalPrecision}} </td>
                        </ng-container>
                        <ng-container matColumnDef="collaborative">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'COLLABORATIVE' | translate}}</th>
                            <td mat-cell class="right-align" *matCellDef="let element"> {{element.collaborative}} </td>
                        </ng-container>
                        <ng-container matColumnDef="currentEditor">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'CURRENT_EDITOR' | translate}}</th>
                            <td mat-cell class="right-align" *matCellDef="let element"> {{element.currentEditor}} </td>
                        </ng-container>
                        <ng-container matColumnDef="costApproved">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'COST_APPROVED' | translate}}</th>
                            <td mat-cell class="right-align" *matCellDef="let element"> {{element.costApproved}} </td>
                        </ng-container>

                        <!-- Header row -->
                        <tr mat-header-row *matHeaderRowDef="displayedColumnsEstimateSearch; sticky: true"
                            class="white-space-nowrap"></tr>
                        <!-- Data rows -->
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsEstimateSearch;"
                            (click)="selection.toggle(row)" (dblclick)="onDblClick(row)"
                            [class.selected]="selection.isSelected(row)" class="white-space-nowrap cur-ptr">

                            <!-- Row shown when there is no matching data -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell no-data" [attr.colspan]="displayedColumnsEstimateSearch.length">
                                {{'NO_DATA_FOUND' | translate}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            @if (totalCount > 0) {
            <div class="open-estimate-footer">
                <div class="col-sm-12 row mat-paginator-sticky paginationDiv">
                    <div class="col-sm-3 pt-3">
                        <div class="goToTextBox">
                            <input type="number" min="1" [max]="totalPages" class="form-control form-control-sm"
                                [(ngModel)]="gotoPageNumber" (keyup.enter)="gotoPage()"
                                placeholder="{{'GOTO' | translate}}">
                        </div>
                        <div>
                            <p class="currentTotalLable">
                                {{'COMMON_LABELS.PAGES' | translate}}: {{currentPageNumber}} {{'COMMON_LABELS.OF' |
                                translate}}
                                {{totalPages}}
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-9 currentTotalLable">
                        <mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageIndex]="currentPageNumber - 1"
                            [showFirstLastButtons]="true" [hidePageSize]="true" (page)="onPageChange($event)">
                        </mat-paginator>
                    </div>
                </div>
            </div>
            }
            <br>
        </div>
    </div>

    <div class="open-estimate-footer d-flex justify-content-end" align="end">
        <!-- TODO : -->
        <!-- <button mat-raised-button color="primary">{{'HELP' | translate}}</button> -->
        <!-- <button mat-raised-button 
        (click)="openEstimate()" 
        [disabled]="!selection.hasValue()"
        color="primary">{{'OPEN' | translate}}</button> -->
        @if (fromCreateOpportunity) {
        <button mat-raised-button (click)="selectEstimate()" [disabled]="!selection.hasValue()"
            color="primary">{{'SELECT' | translate}}
        </button>
        } @else {
        <button class="openCloseBtn" mat-raised-button (click)="openEstimate()" [disabled]="!selection.hasValue()"
            color="primary">{{'OPEN' | translate}}</button>
        }

        <button mat-raised-button color="primary" (click)="resetForm()">{{'RESET' | translate}}</button>
        <!-- TODO: need to check if required or not -->
        <button mat-raised-button color="warn" (click)="dismissClick()">{{'CLOSE' | translate}}</button>

    </div>
</div>